import { ActionType, PieceAction } from '../actions/action'
import { FlowVersion } from '../flow-version'
import { PieceTrigger, TriggerType } from '../triggers/trigger'
import { flowStructureUtil, Step } from './flow-structure-util'

// Pieces/actions reserved for the Business plan — locked when the policy has
// advancedPiecesEnabled = false (Smart tier, no_access).
export const ADVANCED_PIECE_NAMES: ReadonlySet<string> = new Set([
    '@activepieces/piece-subflows',
    '@activepieces/piece-delay',
    '@activepieces/piece-date-helper',
    '@activepieces/piece-image-helper',
    '@activepieces/piece-math-helper',
    '@activepieces/piece-file-helper',
    '@activepieces/piece-text-helper',
    '@activepieces/piece-crypto',
    '@activepieces/piece-csv',
    '@activepieces/piece-xml',
    '@activepieces/piece-connections',
    '@activepieces/piece-sftp',
    '@activepieces/piece-http',
    '@activepieces/piece-smtp',
    '@activepieces/piece-store',
    '@activepieces/piece-tags',
    '@activepieces/piece-qrcode',
])

export const ADVANCED_CORE_ACTIONS: ReadonlySet<string> = new Set([
    ActionType.CODE,
    ActionType.LOOP_ON_ITEMS,
])

export type BlockingStep = {
    stepName: string
    displayName: string
    pieceName?: string
    type: ActionType | TriggerType
}

const isPieceStep = (step: Step): step is PieceAction | PieceTrigger =>
    step.type === ActionType.PIECE || step.type === TriggerType.PIECE

export const isStepLocked = (
    step: Step,
    advancedPiecesEnabled: boolean,
): boolean => {
    if (advancedPiecesEnabled) {
        return false
    }
    if (isPieceStep(step)) {
        return ADVANCED_PIECE_NAMES.has(step.settings.pieceName)
    }
    return ADVANCED_CORE_ACTIONS.has(step.type)
}

export const getBlockingSteps = (
    flowVersion: FlowVersion,
    advancedPiecesEnabled: boolean,
): BlockingStep[] =>
    flowStructureUtil
        .getAllSteps(flowVersion)
        .filter((step) => isStepLocked(step, advancedPiecesEnabled))
        .map((step) => ({
            stepName: step.name,
            displayName: step.displayName,
            pieceName: isPieceStep(step) ? step.settings.pieceName : undefined,
            type: step.type,
        }))
